import { buildLocalizedPagePath } from "@/lib/localized-page-path";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function buildEditorialHubPath(locale: ViewerLocale): string {
  return buildLocalizedPagePath(locale, "editorial");
}
